export default __webpack_public_path__ + "eb4e389e046814d782b16e7179c7ddbb.svg";